module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    staticClass: "mb-6",
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.close()
            }
          }
        }, 'v-btn', attrs, false), [_c('v-icon', [_vm._v("close")])], 1)]
      }
    }]),
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbar.nachricht) + "\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb1dc02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/snackbar.vue
// module id = 763
// module chunks = 15